import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

export const ContentBlocks = ({ blocks }) => {
	return (
		<>
			{blocks.map(block => {
				if (block.id.includes('Subheading')) return <Subheading key={block.id} {...block} />
				if (block.id.includes('Content')) return <Content key={block.id} {...block} />
				if (block.id.includes('Spacer')) return <Spacer key={block.id} {...block} />
				if (block.id.includes('Quote')) return <Quote key={block.id} {...block} />
				if (block.id.includes('Image')) return <Image key={block.id} {...block} />
				if (block.id.includes('Youtube')) return <Video key={block.id} {...block} />
				return null
			})}
		</>
	)
}

const Quote = ({ content }) => {
	return (
		<div className='max-900 ma m-mwa quote-wrapper'>
			<p className='quote m0 balance'>{content}</p>
		</div>
	)
}

const Content = ({ content }) => {
	return <div className='content medium circ-std normal lh-14 max-450 ma m-mwa balance' dangerouslySetInnerHTML={{ __html: content }} />
}

const Image = ({ image }) => {
	return (
		<div className='pos-rel w-100 overflow ratio-3-2 max-700 ma'>
			<GatsbyImage image={image.gatsbyImageData} alt='' className='bg-image' />
		</div>
	)
}

const Video = ({ video }) => {
	return (
		<div className='pos-rel w-100 overflow ratio-3-2 ma'>
			<iframe frameborder='0' width='100%' height='100%' src={`https://www.youtube.com/embed/${video?.providerUid}?playsinline=1`} />
		</div>
	)
}

const Subheading = ({ subheading }) => {
	return <p className='max-700 w-100 h3 ma'>{subheading}</p>
}

const Spacer = ({}) => <div className='mt40' role='presentation' />
